"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BytesCoder = exports.DynamicBytesCoder = void 0;

var _bytes = require("@ethersproject/bytes");

var _abstractCoder = require("./abstract-coder");

class DynamicBytesCoder extends _abstractCoder.Coder {
  constructor(type, localName) {
    super(type, type, localName, true);
  }

  encode(writer, value) {
    value = (0, _bytes.arrayify)(value);
    let length = writer.writeValue(value.length);
    length += writer.writeBytes(value);
    return length;
  }

  decode(reader) {
    return reader.readBytes(reader.readValue().toNumber());
  }

}

exports.DynamicBytesCoder = DynamicBytesCoder;

class BytesCoder extends DynamicBytesCoder {
  constructor(localName) {
    super("bytes", localName);
  }

  decode(reader) {
    return reader.coerce(this.name, (0, _bytes.hexlify)(super.decode(reader)));
  }

}

exports.BytesCoder = BytesCoder;